import React, { useRef } from "react";
import "./DamageImage.css";
import damageBlank from "../images/damageBlank.jpeg";

const clamp = (n, min, max) => Math.min(Math.max(n, min), max);
const toFiniteNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const normalizeDamagePosition = (pos) => {
    if (!pos || typeof pos !== "object") return null;

    const xPct = toFiniteNumber(pos.xPct);
    const yPct = toFiniteNumber(pos.yPct);
    if (xPct != null && yPct != null) {
        return {
            xPct: clamp(xPct, 0, 100),
            yPct: clamp(yPct, 0, 100),
        };
    }

    // Backwards compatibility for older payloads that used x/y.
    const xRaw = toFiniteNumber(pos.x);
    const yRaw = toFiniteNumber(pos.y);
    if (xRaw == null || yRaw == null) return null;

    const isUnitRange = xRaw >= 0 && xRaw <= 1 && yRaw >= 0 && yRaw <= 1;
    return {
        xPct: clamp(isUnitRange ? xRaw * 100 : xRaw, 0, 100),
        yPct: clamp(isUnitRange ? yRaw * 100 : yRaw, 0, 100),
    };
};

const DamageImage = ({ damagePositions = [], onImageClick, className = "" }) => {
    const imgRef = useRef(null);
    const normalizedDamagePositions = Array.isArray(damagePositions) ? damagePositions.map(normalizeDamagePosition).filter(Boolean) : [];

    const handleClick = (e) => {
        if (!onImageClick || !imgRef.current) return;

        const rect = imgRef.current.getBoundingClientRect();
        const xPct = clamp(((e.clientX - rect.left) / rect.width) * 100, 0, 100);
        const yPct = clamp(((e.clientY - rect.top) / rect.height) * 100, 0, 100);

        onImageClick({
            xPct: Number(xPct.toFixed(4)),
            yPct: Number(yPct.toFixed(4)),
        });
    };

    return (
        <div
            className={`vehicle-image-container ${className}`}
            onClick={handleClick}>
            <img
                ref={imgRef}
                src={damageBlank}
                alt="Vehicle"
                className="vehicle-image"
            />
            {normalizedDamagePositions.map((pos, index) => (
                <div
                    key={index}
                    className="damage-mark"
                    style={{
                        left: `${pos.xPct.toFixed(4)}%`,
                        top: `${pos.yPct.toFixed(4)}%`,
                    }}></div>
            ))}
        </div>
    );
};

export default DamageImage;
